import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Grid, Typography, useTheme} from "@mui/material";
import {BORDER_RADIUS_LARGE, CARD_SHADOW, PD_LG, PD_MD, PD_SM} from "@/shared/dimens";
import {gray} from "@/shared/colors";
import {TeamSectionData} from "../../types";

export function TeamSection(props: { data: TeamSectionData }): ReactElement {
  const theme = useTheme();
  return <SectionContainer>
    <StyledBoxColumn style={{gap: PD_SM}}>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      {props.data.subtitle
        ? <Typography style={{opacity: 0.6, lineHeight: 1.7}}>{props.data.subtitle}</Typography>
        : null}
    </StyledBoxColumn>
    <Grid container>
      {props.data.members.map((member, i) =>
        <Grid key={i} xs={12} sm={6} md={4} style={{display: "flex", padding: PD_MD}}>
          <StyledBoxColumn style={{
            width: "100%",
            borderRadius: 0,
            boxShadow: CARD_SHADOW,
            overflow: "hidden",
            backgroundColor: "#fff",
            gap: 0,
          }}>
            <div style={{
              width: "100%",
              position: "relative",
              aspectRatio: "3/4",
              background: gray,
            }}>
              <img
                src={member.photoUrl}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center top",
                }}/>
              <div style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: 4,
                backgroundColor: theme.palette.primary.main,
              }}/>
            </div>
            <StyledBoxColumn style={{padding: PD_LG, gap: PD_SM}}>
              <StyledBoxColumn style={{gap: PD_MD / 4}}>
                <StyledHeadingVariant default_={4}>{member.name}</StyledHeadingVariant>
                <Typography style={{color: theme.palette.primary.main, fontWeight: "600", fontSize: "90%"}}>
                  {member.role}
                </Typography>
              </StyledBoxColumn>
              {member.bio
                ? <Typography variant="body2" style={{opacity: 0.65, lineHeight: 1.7}}>
                  {member.bio}
                </Typography>
                : null}
            </StyledBoxColumn>
          </StyledBoxColumn>
        </Grid>
      )}
    </Grid>
  </SectionContainer>;
}
